<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 sm12 md12>
        <v-card elevation="1">
          <v-card-text style="margin-bottom: -35px">
            <v-layout row>
              <v-flex xs12 sm8 offset-sm2 md8 offset-md2 style="text-align: center">
                <v-icon :size="80" color="primary">
                  insert_drive_file
                </v-icon>
                <h2 style="color: #1a1a1a; margin: 10px 0px">Import from a CSV file</h2>

                <p style="color: #242424; font-size: 14px; ">Download the sample file and get started</p>
                <v-btn color="primary" href="./sampleData/BulkAttendanceSample.csv" download
                  >Download</v-btn
                >
              </v-flex>

              <v-flex xs12 sm8 offset-sm2 md8 offset-md2 style="text-align: center">
                <h5 style="color: #1a1a1a; margin: 7px 0px; font-size: 11px; font-weight: 400">
                  Note: Fill the sample file and upload
                </h5>
                <v-file-input label="File input" outlined dense @change="upload"></v-file-input>
              </v-flex>
            </v-layout>
          </v-card-text>
          <!--Table selection  -->
          <v-flex xs12 sm10 offset-sm1 v-if="fileName">
            <v-card style="margin: 10px 5px 10px 5px; padding: 5px 25px;" elevation="0">
              <v-layout wrap>
                <!-- <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Location Name'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Location Name"
                                    :items = "headerList"
                                    v-model="bulkSelected.LocationName"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Email'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Email"
                                    :items = "headerList"
                                    v-model="bulkSelected.Email"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Punch Type'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Punch Type"
                                    :items = "headerList"
                                    v-model="bulkSelected.Punch"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>


                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Time'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Time"
                                    :items = "headerList"
                                    v-model="bulkSelected.Time"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Date'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Date"
                                    :items = "headerList"
                                    v-model="bulkSelected.Date"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex> -->

                <!-- start button -->
                <v-flex xs12 sm12 md12 style="text-align: center; margin: 5px 0px">
                  <p class="bi_p" v-if="fileName">Your selected file is - {{ fileName }}</p>
                  <v-btn color="primary" style="margin: 5px 0px" :disabled="uploaded" @click="save"
                    >Start</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="finishDialog" max-width="800" persistent>
      <v-card>
        <v-card-text>
          <v-container>
            <v-layout wrap>
              <v-flex
                xs12
                sm12
                md12
                v-if="dataProcessed.length > 0"
              >
                <v-layout row>
                  <v-flex xs12 sm12>
                    <v-data-table :headers="headers" class="elevation-1" :items="dataProcessed">
                      <!-- <template v-slot:items="props">
                        <td>{{ props.item.data.Email }}</td>
                        <td>{{ props.item.message }}</td>
                        <td>{{ props.item.success }}</td>
                      </template> -->
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 v-else style="text-align: center">
                <v-icon :size="80" color="success">
                  check_circle_outline
                </v-icon>
                <h2 style="color: #1a1a1a; margin: 15px 0px">Successfully uploaded</h2>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="border-radius: 2px;" color="primary" @click="close">Finish</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- loader -->
    <v-dialog
      v-model="loader"
      persistent
      width="300"
      style="box-shadow: none !important;  background-color: transparent !important"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Papa from "papaparse";
import Blob from "blob";
import FileSaver from "file-saver";

export default {
  name: "parse",
  data() {
    return {
      loader: false,
      uploaded: false,
      finishDialog: false,
      dataProcessed: [],
      fileName: "",
      headerList: [],
      results: {},
      allowedLocation: [],
      // bulk import fields
      bulkSelected: {
        LocationName: "",
        Email: "",
        Punch: "",
        Time: "",
        Date: ""
      },
      headers: [
        {
          text: "Email ID",
          align: "left",
          sortable: false,
          value: "email"
        },
        { text: "Reason", value: "message", sortable: false },
        { text: "Success", value: "success", sortable: false }
      ]
    };
  },
  created() {
    this.getAllLocaton();
  },
  methods: {
    close() {
      var self = this;
      self.finishDialog = false;
      self.$router.replace({ name: "Timesheet" });
    },
    getAllLocaton() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}locations?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allowedLocation = response.body;
        
        })
        .catch(err => {
           console.log('Error', err);
        });
    },
    upload(e) {
      const self = this;
      self.fileName = e.name;
      const fileToLoad = event.target.files[0];
      const reader = new FileReader();

      reader.onload = fileLoadedEvent => {
        Papa.parse(fileLoadedEvent.target.result, {
          header: true,
          skipEmptyLines: true,
          complete(results) {
            self.doc = JSON.stringify(results.data, null, 2);
            self.results = results.data;
           
            const head = Object.keys(results.data[0]);
            self.headerList = head;
            // Gussing the headers
            const mySelections = Object.keys(self.bulkSelected);
            mySelections.forEach(ms => {
              self.bulkSelected[ms] =
                _.find(
                  head,
                  o =>
                    o
                      .replace(" ", "")
                      .toLowerCase()
                      .trim() ==
                    ms
                      .replace(" ", "")
                      .toLowerCase()
                      .trim()
                ) || "";
            });
          },
          error(errors) {
            
          }
        });
      };
      reader.readAsText(fileToLoad);
    },
    save() {
      const self = this;
      const { bulkSelected } = this;
      let data = this.results;

      let hasError = false;
      for (const x in bulkSelected) {
        if (bulkSelected[x] == "") hasError = true;
      }

      if (hasError) {
        this.$swal({ type: "warning", text: "Please use the provided template" });
        return;
      }

      if (self.$store.state.userDetails.role.toLowerCase() != "superadmin") {
        self.$swal({
          type: "warning",
          text: "Only Superadmin is allowed to operate Bulk operation"
        });
        return;
      }

      self.loader = true;
      self.dataProcessed = []

      data = _.map(data, d => {
        let errors = false;

        // email check
        if(d.Email.trim() == ""){
          errors = true
          d.Email =  "Email ID not found"
          self.dataProcessed.push({
            email: d.Email,
            message: "Email ID is not provided",
            success: false
          })
        }

        // checking for the location name
        const isLocNameValid = _.includes(
          _.map(d.LocationName.split(","), ln => {
            if (
              _.find(self.$store.getters.locationDetails, al => {
                return al.name == ln;
              })
            ) {
              return true;
            } else {
              return false;
            }
          }),
          true
        );
        if (!isLocNameValid) {
          errors = true;
          self.dataProcessed.push({
            email: d.Email,
            message: "Unassigned/Incorrect location",
            success: false
          });
        }

        // checking for empty fields
        if(d.Time.trim() == "" || d.Date.trim() == ""){
          errors = true
          self.dataProcessed.push({
            email: d.Email,
            message: "Time and/or Date is not provided",
            success: false
          })
        }

        // checking for empty punch
        if(d.Punch.trim() == ""){
          errors = true
          self.dataProcessed.push({
            email: d.Email,
            message: "Punch type is not provided",
            success: false
          })
        }

        

        if (!errors) {
          return d;
        }
      })
      
      data = _.remove(data, undefined)

      const postObj = {
        data,
        selected: {
          LocationName: bulkSelected.LocationName,
          Email: bulkSelected.Email,
          Punch: bulkSelected.Punch,
          Time: bulkSelected.Time,
          Date: bulkSelected.Date
        }
      }

      self.uploaded = true;

      this.$http
        .post(`${this.$store.state.endpoint}attendances/bulk/import`, postObj)
        .then(response => {
          
          for (var x in response.body) {
            var errors = response.body[x].errors;
            _.each(errors, e => {
              return (errors = e);
            });
            
            self.dataProcessed.push({
              email: response.body[x].email,
              message: errors,
              success: response.body[x].success
            });
          }
          self.finishDialog = true;
          self.loader = false;
        })
        .catch(err => {
          self.loader = false
          self.uploaded = false
          self.$swal({ type: "error", text: "Sorry, try again later" });
        });
    }
  }
};
</script>
<style scoped>

label {
  font-size: 13px;
  letter-spacing: 0.5px;
  padding: 8px;
  background-color: #4779d4;
  color: #ffffff;
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 1px 2px 4px #bbc8e2;
}
.bi_p {
  font-size: 12px;
  margin: 10px 0px 2px 0px;
  font-weight: 600;
}
.bi_execute {
  font-size: 14px;
  text-transform: none;
  box-shadow: 1px 2px 20px #ebeaea !important;
  border-radius: 2px;
  font-weight: 400;
}
hr {
  margin: 10px 0px 10px 0px;
  border: 0.5px solid #ebeaea;
}
.bi_subheader {
  margin-top: 20px;
}
.bi_card {
  box-shadow: 1px 2px 20px #ebeaea !important;
  padding: 15px;
  text-align: center;
}
.bi_card2 {
  margin: 10px 5px 10px 5px;
  box-shadow: 1px 2px 20px #ebeaea !important;
  padding: 25px;
}
h3 {
  font-size: 16px;
  letter-spacing: 0.5px;
  margin: 5px 0px 10px 0px;
}
p {
  font-size: 13px;
  letter-spacing: 0.5px;
  /* text-align: left; */
  font-weight: 600;
}
.bi_btn {
  font-size: 14px;
  text-transform: none;
  box-shadow: 1px 2px 20px #ebeaea !important;
  border-radius: 2px;
  font-weight: 400;
  margin-top: -5px;
}
.bi_file {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
}
.bi_selectFile {
  font-weight: 600;
  letter-spacing: 0.5px;
  font-size: 14px;
  cursor: pointer;
  padding: 5px;
}
</style>
